import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "field"]

  static values = {
    confirmWhen: String,
    initiallyActive: Boolean,
    initialValue: String,
    fieldName: String,
  }

  connect() {
    this.confirmed = false
  }

  submit(event) {
    if (this.confirmed) return
    if (!this.shouldConfirm()) return

    event.preventDefault()
    event.stopImmediatePropagation()

    if (event.detail?.formSubmission) {
      event.detail.formSubmission.stop()
    }

    this.openModal()
  }

  confirm(event) {
    event.preventDefault()
    this.confirmed = true
    this.closeModal()
    this.formElement?.requestSubmit()
  }

  cancel(event) {
    event.preventDefault()
    this.closeModal()
  }

  shouldConfirm() {
    const field = this.fieldElement
    if (!field) return false

    switch (this.confirmWhenValue) {
      case "unchecked-while-active":
        return this.initiallyActiveValue && !field.checked
      case "value-changed":
        return field.value !== this.initialValueValue
      default:
        return false
    }
  }

  openModal() {
    const dialog = this.dialogElement
    if (!dialog) return

    if (typeof dialog.showModal === "function") {
      dialog.showModal()
    } else {
      dialog.style.display = "block"
    }
  }

  closeModal() {
    const dialog = this.dialogElement
    if (!dialog) return

    if (typeof dialog.close === "function") {
      dialog.close()
    } else {
      dialog.style.display = "none"
    }
  }

  get formElement() {
    return this.element.querySelector("form")
  }

  get fieldElement() {
    if (this.hasFieldTarget) return this.fieldTarget
    if (!this.hasFieldNameValue) return null

    return this.element.querySelector(`[name="${this.fieldNameValue}"]`)
  }

  get dialogElement() {
    if (!this.hasModalTarget) return null

    return this.modalTarget.querySelector("dialog")
  }
}
